<template>
	<div class="header">
		<div class="section-action">
			<UiButtonMenu
				class="btn__menu"
				@click="openSideBar"
			/>
		</div>
		<HeaderConnectionStatus class="status" />
		<div class="header__wrapper">
			<div class="section-info">
				<!-- <Logo
				class="logo"
				variant-logo="header"
				heightLogo="35px"
				width-logo="110px"
			/> -->
				<!-- {{ headerInfoComputed }} -->
				<div class="card__info-driver">
					<UiIcon
						name="profile-circle"
						folder="profile"
						width="24px"
						color="var(--white)"
					/>
					<div class="content">
						<TypographyKTypographyBody6
							class="title"
							color="#D4D4DD"
							>{{ 'Дальнобойщик' }}</TypographyKTypographyBody6
						>

						<TypographyKTypographyBody5
							class="subtitle"
							color="var(--white)"
							>{{ headerInfoComputed?.name }}</TypographyKTypographyBody5
						>
					</div>
				</div>

				<div class="card__info-driver notification-btn">
					<UiButtonIcon
						background="transparent"
						padding="0"
						:badge="headerInfoComputed?.countUnreadMessages"
						class="btn-icon"
						@click="openModalNotification"
					>
						<Icon
							name="material-symbols:notifications-outline"
							folder="profile"
							width="24px"
							color="var(--white)"
						/>
					</UiButtonIcon>
				</div>
			</div>
		</div>
	</div>
	<UiModalNotification
		v-model="modal.notification"
		v-if="modal.notification"
	/>
	<SideBar
		v-if="isSideBarOpen"
		@closeSideBar="closeSideBar"
		@openSupportChat="openSupportChat"
	/>
</template>

<script setup lang="ts">
	import { useDictionariesStore } from '~/store/dictionaries.store';
	import { useLongHaulTripStore } from '~/store/longHaulTrip.store';

	const emits = defineEmits(['openSupportChat']);
	const isSideBarOpen = ref(false);
	const longHaulTripStore = useLongHaulTripStore();
	const headerInfoComputed = computed(() => longHaulTripStore.headerInfo);
	const pageReqInterval = ref<NodeJS.Timeout | null>(null);

	const modal = reactive({
		notification: false
	});

	const getHeaderInfo = async () => {
		await longHaulTripStore.getHeaderInfo();
	};

	const openSideBar = () => {
		isSideBarOpen.value = true;
	};

	const closeSideBar = () => {
		isSideBarOpen.value = false;
	};

	const openSupportChat = () => {
		emits('openSupportChat', '');
	};

	const openModalNotification = () => {
		modal.notification = true;
		console.log('openModalNotification');
	};

	getHeaderInfo();

	onMounted(() => {
		const startInterval = async () => {
			pageReqInterval.value = setTimeout(async () => {
				await getHeaderInfo();
				if (pageReqInterval.value) startInterval();
			}, 20000);
		};
		startInterval();
	});

	onUnmounted(() => {
		if (pageReqInterval.value) {
			clearTimeout(pageReqInterval.value);
			pageReqInterval.value = null;
		}
	});
</script>

<style scoped lang="scss">
	.notification-btn {
		width: fit-content !important;
		cursor: pointer;
		padding: 0px !important;

		.btn-icon {
			width: 40px;
			height: 40px;
		}
	}
	.status {
		margin-bottom: 7px;
	}
	.cargos {
		display: grid;
		grid-template-columns: 1fr 1fr 1fr;
		gap: 8px;

		.cargo {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			gap: 4px;
			background-color: var(--white);
			border-radius: 16px;
			padding: 2px 4px;
			height: 64px;
			cursor: pointer;

			&__icon-wrapper {
				display: flex;
				align-items: center;
				gap: 5px;
			}

			&__title {
				display: flex;
				white-space: nowrap;
				gap: 5px;
			}

			.count {
			}

			&__active {
				border: 1.8px solid; /* резервируем место, если нужно */
				box-shadow: inset 0 0 0 2.5px #264688; /* внутренняя обводка */
			}
		}
	}
	.header {
		display: flex;
		flex-direction: column;
		gap: 0px;
		justify-content: center;
		align-items: center;
		background-color: transparent;
		padding: 20px 0px 0px 0px;
		width: 100%;

		&__wrapper {
			display: flex;
			flex-direction: column;
			width: 100%;
			max-width: 800px;
		}

		.section-cargos {
			display: flex;
			flex-direction: column;
			gap: 14px;
			width: 100%;
			margin-top: 16px;

			.block-date {
				display: flex;
				gap: 10px;
				align-items: center;
			}
		}

		.section-info {
			display: flex;
			align-items: center;
			width: 100%;

			.card__info-driver {
				display: flex;
				align-items: center;
				gap: 10px;
				width: 100%;
				background: linear-gradient(90deg, rgba(239, 242, 246, 0.28) 40%, rgba(185, 177, 228, 0.28) 100%);
				min-height: 40px;
				max-height: 40px;
				border-radius: 12px;
				margin-right: 11px;
				padding: 8px;

				.content {
					display: flex;
					flex-direction: column;
					gap: 3px;
					justify-content: center;
					overflow: hidden;
				}

				&:last-child {
					margin-right: 0px;
				}
			}
		}

		.section-action {
			display: flex;
			align-items: center;
			margin-left: auto;
			margin-bottom: 10px;

			.btn__menu {
				margin-left: 25px;
			}
		}

		@media (max-width: $extra-sm) {
			//padding: 20px 15px;
		}
	}
</style>
